<template>
  <container class="faculty-box">
    <div class="subpage-list" v-if="universityDetails">
      <div class="text-center mb-35">
        <div class="result-bracket__title">
          <span class="result-bracket__count">{{ universityDetails.faculties.length }}</span> Finding !
        </div>
      </div>
      <div class="flex-row">
        <router-link
          class="subpage-list__item"
          v-for="faculty in universityDetails.faculties" :key="faculty.id"
          :to="{ name: 'StudioProduct', params: { slug: $route.params.slug, faculty: faculty.slug } }">
          <faculty-card
            :faculty="faculty"/>
        </router-link>
      </div>
    </div>
  </container>
</template>

<script>
import FacultyCard from '@/components/FacultyCard'
import { mapGetters } from 'vuex'
export default {
  name: 'UniDetailFaculty',
  components: {
    FacultyCard
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['universityDetails'])
  }
}
</script>

<style scoped>
.faculty-box .info-card{
  height: 175px !important;
}
</style>
